export default __webpack_public_path__ + "static/media/other_investment_dark.6d015717.png";